import { environment } from './environment';

export const urls = {
    //BASE_URL:'https://api.ngkntk.com.mx/ngk-api',
    //BASE_URL:'https://api.ngkntk.com.mx/ngk-api',
    BASE_URL: environment.BASE_URL,
    baseFacebookUrl: 'https://www.facebook.com',
    baseGraphUrl: 'https://graph.facebook.com',
    baseYouTubeUrl: 'https://www.youtube.com',
    baseGoogleApiUrl: 'https://www.googleapis.com/youtube/v3',
    baseSiteKey: '6LcC208eAAAAAHYPBxHqqtXdy5Afj0r8VPcIRZh4'
}
